// components/CreateSpaceModal.jsx — Anamoria SPA
// v1.6 — NEW-171 Phase 3 (SPA PR-2 / 2c): optional groupParam prop ('' default), passed straight
//   through to CreateSpaceForm so the leader dashboard can create a group space for the SELECTED
//   cohort (?group=<id>). Default '' = home cohort = byte-identical to v1.5. (Nov 2, 2026)
// 2026-10-18/19: optional initialSpaceType (caller can preselect Private/Group) and onCreated
//   (caller overrides where to go after create). The leader dashboard "+ New group space" entry
//   opens this modal with Group preselected and routes to that group's invite flow on success.
// v1.5 — Consolidation (Sept 17, 2026): this modal now renders <CreateSpaceForm/> for its body +
//   CTA instead of a duplicated inline copy (resolves the v1.2 duplication the note below called
//   out). The shared form owns ALL create logic, including v0.5 relationship + "days to hold close"
//   (flag-gated by relationship_key_dates_enabled). This modal keeps only the modal chrome
//   (overlay, header, close, backdrop) and the success handler (close + navigate to the new space).
//   The duplicate body/cta/input/photo classes in CreateSpaceModal.module.css are now unused —
//   left in place for now; safe to prune in a follow-up.
// v1.4 — space-type control redesigned as a segmented control (Private/Group). (Sept 3, 2026)
// v1.3 — v0.3 space type: leaders choose Private/Group at creation. (Sept 1, 2026)
// v1.2 — Wire photo upload on space creation (April 24, 2026)
// v1.1 — A-4: Update AppContext spaces list after creation (April 22, 2026)
// v1.0 — April 1, 2026

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import CreateSpaceForm from './CreateSpaceForm';
import styles from './CreateSpaceModal.module.css';

export default function CreateSpaceModal({ getApi, onClose, initialSpaceType, onCreated, groupParam = '' }) {
  const navigate = useNavigate();

  // CreateSpaceForm updates the AppContext spaces list itself. By default the modal
  // closes and navigates to the new space's feed; a caller may override where to go
  // next via onCreated(newSpaceId) (e.g. the leader invite flow).
  const handleSuccess = useCallback((newSpaceId) => {
    onClose();
    if (onCreated) { onCreated(newSpaceId); return; }
    navigate(`/spaces/${newSpaceId}`);
  }, [onClose, navigate, onCreated]);

  const handleBackdropClick = useCallback((e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  }, [onClose]);

  return (
    <div className={styles.overlay} onClick={handleBackdropClick}>
      <div className={styles.modal}>

        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>Create a Space</h2>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="Close"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Body + CTA — shared with the /spaces/new route */}
        <CreateSpaceForm getApi={getApi} onSuccess={handleSuccess} ctaLabel="Next" initialSpaceType={initialSpaceType} groupParam={groupParam} />

      </div>
    </div>
  );
}
